module.exports = __webpack_public_path__ + "static/slo-moe-6d9a9c724b5e5604da4b0568740533a6.png";